import React from 'react';
import styles from './StanMultiRowFileDropZonePreview.module.css';
import { StanFileDropZonePreviewRow } from '../PreviewRow/StanFileDropZonePreviewRow';
import { FileState } from '@/hooks/useFileUpload';

export type StanFileDropZonePreviewProps = {
    fileStates: FileState[];
    onDelete: (idx: number) => void;
};

export const StanFileDropZonePreview: React.FC<StanFileDropZonePreviewProps> = ({ fileStates, onDelete }) => {
    if (!fileStates.length) return null;
    return (
        <div className={styles.uploadedFilesContainer}>
            <ul className='flex w-full flex-col gap-2'>
                {fileStates.map((f, idx) => (
                    <StanFileDropZonePreviewRow
                        key={f.file.name + f.file.lastModified}
                        fileState={f}
                        idx={idx}
                        onDelete={onDelete}
                    />
                ))}
            </ul>
        </div>
    );
};
